module.exports = ":host [mat-dialog-actions] {\n  text-align: right;\n  margin-top: 30px; }\n"